import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"

import { RootState } from "../store"

export const productionApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: `${import.meta.env.VITE_APP_API_URL}/${import.meta.env.VITE_APP_API_VERSION}`,
    prepareHeaders: (headers, { getState }) => {
      const state = getState() as RootState
      const authToken = state.auth.masquerade_access_token || state.auth.api_access_token
      const tokenType = state.auth.token_type
      headers.set("Content-Type", "application/json")
      headers.set("Accept", "application/json")
      if (authToken) {
        headers.set("authorization", `${tokenType} ${authToken}`)
      }
      return headers
    },
  }),

  reducerPath: "productionApi",
  tagTypes: ["Quiz", "Answer"],
  endpoints: (builder) => ({
    getExcludedPools: builder.query<any, void>({
      query: () => "/admin/production/team/pools/excluded",
    }),

    getIncludedPools: builder.query<any, void>({
      query: () => "/admin/production/team/pools/included",
    }),

    includePools: builder.mutation<any, any>({
      query: (payload) => ({
        url: "/admin/production/team/pools/include",
        method: "POST",
        body: payload,
      }),
    }),

    excludePools: builder.mutation<any, any>({
      query: (payload) => ({
        url: "/admin/production/team/pools/exclude",
        method: "POST",
        body: payload,
      }),
    }),
  }),
})

export const {
  useExcludePoolsMutation,
  useGetExcludedPoolsQuery,
  useGetIncludedPoolsQuery,
  useIncludePoolsMutation,
  useLazyGetExcludedPoolsQuery,
  useLazyGetIncludedPoolsQuery,
} = productionApi
